import axios from 'axios';
import { ENDPOINTS } from '../constants/endpoints';
import { AuthService } from './auth.service';
import {
    IOrderBook, IOrderBookFilters, IOrderDashboardFilters, IOrderDashboardResponse,
    ISampleTracker, ISampleTrackerFilters, ISampleWorkload, ISampleWorkloadFilters,
} from '../interfaces/garments/merchReport.interface';
import { IMaterialRequirement } from '../interfaces/garments/materialRequirement.interface';

const headers = () => AuthService.getAuthHeader();

export const MerchReportService = {
    getOrderBook: async (institutionId: string, filters: IOrderBookFilters = {}): Promise<IOrderBook> => {
        const res = await axios.get(ENDPOINTS.MERCHANDISING_REPORT.ORDER_BOOK(institutionId), {
            headers: headers(),
            params: filters,
        });
        return res.data;
    },

    // Returns the raw blob; callers trigger the download via `triggerDownload`
    // (components/statutoryRegisters/shared.ts, G21) and handle failures with `showApiError`.
    downloadOrderBookXlsx: async (institutionId: string, filters: IOrderBookFilters = {}): Promise<Blob> => {
        const res = await axios.get(ENDPOINTS.MERCHANDISING_REPORT.ORDER_BOOK_XLSX(institutionId), {
            headers: headers(),
            params: filters,
            responseType: 'blob',
        });
        return res.data;
    },

    getSampleTracker: async (institutionId: string, filters: ISampleTrackerFilters = {}): Promise<ISampleTracker> => {
        const res = await axios.get(ENDPOINTS.MERCHANDISING_REPORT.SAMPLE_TRACKER(institutionId), {
            headers: headers(),
            params: filters,
        });
        return res.data;
    },

    downloadSampleTrackerXlsx: async (institutionId: string, filters: ISampleTrackerFilters = {}): Promise<Blob> => {
        const res = await axios.get(ENDPOINTS.MERCHANDISING_REPORT.SAMPLE_TRACKER_XLSX(institutionId), {
            headers: headers(),
            params: filters,
            responseType: 'blob',
        });
        return res.data;
    },

    getMaterialRequirement: async (institutionId: string, buyerOrderId: string): Promise<IMaterialRequirement> => {
        const res = await axios.get(ENDPOINTS.MERCHANDISING_REPORT.MATERIAL_REQUIREMENT(institutionId, buyerOrderId), {
            headers: headers(),
        });
        return res.data;
    },

    getOrderDashboard: async (institutionId: string, filters: IOrderDashboardFilters = {}): Promise<IOrderDashboardResponse> => {
        const res = await axios.get(ENDPOINTS.MERCHANDISING_REPORT.ORDER_DASHBOARD(institutionId), {
            headers: headers(),
            params: filters,
        });
        return res.data;
    },

    downloadOrderDashboardXlsx: async (institutionId: string, filters: IOrderDashboardFilters = {}): Promise<Blob> => {
        const res = await axios.get(ENDPOINTS.MERCHANDISING_REPORT.ORDER_DASHBOARD_XLSX(institutionId), {
            headers: headers(),
            params: filters,
            responseType: 'blob',
        });
        return res.data;
    },

    getSampleWorkload: async (institutionId: string, filters: ISampleWorkloadFilters): Promise<ISampleWorkload> => {
        const res = await axios.get(ENDPOINTS.MERCHANDISING_REPORT.SAMPLE_WORKLOAD(institutionId), {
            headers: headers(),
            params: filters,
        });
        return res.data;
    },

    downloadSampleWorkloadXlsx: async (institutionId: string, filters: ISampleWorkloadFilters): Promise<Blob> => {
        const res = await axios.get(ENDPOINTS.MERCHANDISING_REPORT.SAMPLE_WORKLOAD_XLSX(institutionId), {
            headers: headers(),
            params: filters,
            responseType: 'blob',
        });
        return res.data;
    },
};
